const isInViewport = element => {
    if (!element) return
    const rect = element.getBoundingClientRect()

    return (
        rect.bottom >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    )
}

const loadLocationMenuScroll = () => {
    const locationNav = document.querySelector('.location-nav')
    const locationNavLinks = document.querySelectorAll('.location-nav a')

    if (locationNav) {
        window.addEventListener('scroll', () => {
            for (let i = 0; i < locationNavLinks.length; i++) {
                const anchor = locationNavLinks[i].href.split('#')[1]
                const element = document.getElementById(anchor)

                if (isInViewport(element)) {
                    removeAllActiveClasses()
                    locationNavLinks[i].classList.add('active')
                }
            }
        })
    }
}

const removeAllActiveClasses = () => {
    const locationNavLinks = document.querySelectorAll('.location-nav a')

    for (let i = 0; i < locationNavLinks.length; i++) {
        locationNavLinks[i].classList.remove('active')
    }
}

export default loadLocationMenuScroll



// WEBPACK FOOTER //
// ./js/locationMenuScroll.js